import React, { useEffect, useState } from 'react';
import ReactPaginate from "react-paginate";
import Reveal from "../components/Reveal";
import "../styles/Gallery.css";
import heroBg from "../assets/gallerybanner.jpg";
import infoIcon from "../assets/info-icon.png";

function Items({ currentItems }) {
    return (
        <>
            {currentItems && currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                    <div key={item.url || index} className="gallery-item card">
                        <div className="card-img-wrap">
                            <img src={item.url || infoIcon} alt={item.caption || "Gallery Image"} className="card-img" onError={(e) => {e.target.src = infoIcon}}/>
                        </div>
                        {item.caption && <div className="card-content"><p>{item.caption}</p></div>}
                    </div>
                ))
            ) : (
                <p>No gallery images found.</p>
            )}
        </>
    );
}

function PaginatedItems({ itemsPerPage, galleryItems }) {
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = galleryItems.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(galleryItems.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % galleryItems.length;
        setItemOffset(newOffset);
    };

    return (
        <div className="gallery-page-section">
            <div className="gallery-grid">
                <Items currentItems={currentItems} />
            </div>
            {pageCount > 1 && (
                <ReactPaginate className="paginate"
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="<"
                    renderOnZeroPageCount={null}
                />
            )}
        </div>
    );
}

function Gallery() {
    const [galleryData, setGalleryData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchGallery = async () => {
            try {
                setLoading(true);
                const res = await fetch('/api/gallery');
                const data = await res.json();
                setGalleryData(data.images || []);
            } catch (e) {
                console.error("Gallery fetch error:", e);
                setGalleryData([]);
            } finally {
                setLoading(false);
            }
        };
        fetchGallery();
    }, []);

    return (
        <div className="gallery-page">
            <div className="page-header" style={{ backgroundImage: `url(${heroBg})` }}>
                <div className="overlay"></div>
                <div className="container header-content">
                    <Reveal>
                        <h1>Gallery</h1>
                        <p>Moments from our vibrant community.</p>
                    </Reveal>
                </div>
            </div>

            <section className="section" id="images">
                <div className="container">
                    <Reveal>
                        <div className="section-header">
                            <h2>Our Photo Gallery</h2>
                        </div>
                        {loading ? (
                            <p>Loading gallery...</p>
                        ) : (
                            <PaginatedItems itemsPerPage={12} galleryItems={galleryData} />
                        )}
                    </Reveal>
                </div>
            </section>
        </div>
    );
}

export default Gallery;
